import React from "react";
import { Card } from "@cmsgov/ds-medicare-gov";
import { useTranslate, sendTealiumEvent } from "../../../helpers";
import { MedigapPlanPolicy } from "../utils/plans";

const MedigapPolicyCard: React.FunctionComponent<{
  policy: MedigapPlanPolicy;
}> = ({ policy }) => {
  const t = useTranslate();

  return (
    <Card className="MedigapPolicyCard">
      <section className="MedigapPolicyCard__header">
        <h2>{t(policy.company)}</h2>
      </section>
      <div className="MedigapPolicyCard__body">
        <section className="MedigapPolicyCard__contact_info">
          <h3 className="MedigapPolicyCard__section_heading">
            {t("medigap.policies.contact_company")}
          </h3>
          <div className="MedigapPolicyCard__line_item">
            <b>{t("medigap.address")}:</b> {policy.address}
          </div>
          <div className="MedigapPolicyCard__line_item">
            <b>{t("medigap.phone_number")}:</b>{" "}
            <a
              href={`tel:${policy.phone_number}`}
              onClick={(): void => {
                sendTealiumEvent(
                  "Step 2: Pick your policy",
                  `Result: Phone ${policy.company}`
                );
              }}
            >
              {policy.phone_number}
            </a>
          </div>
          <div className="MedigapPolicyCard__line_item">
            <a
              href={policy.website}
              className="mct-hide-print"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(): void => {
                sendTealiumEvent(
                  "Step 2: Pick your policy",
                  `Result: Website ${policy.company}`
                );
              }}
            >
              {t("medigap.policies.visit_company_website")}
            </a>
            <span className="mct-print-only">{policy.website}</span>
          </div>
        </section>
        <div className="MedigapPolicyCard__divider"></div>
        <section className="MedigapPolicyCard__pricing_info">
          <h3 className="MedigapPolicyCard__section_heading">
            {t(`medigap.rate_type.heading.${policy.rate_type.toLowerCase()}`)}
          </h3>
          <p>
            {t(
              `medigap.rate_type.description.${policy.rate_type.toLowerCase()}`
            )}
          </p>
          <p>
            <a
              href="https://medicare.gov/supplements-other-insurance/whats-medicare-supplement-insurance-medigap/medigap-costs/costs-of-medigap-policies"
              className="mct-hide-print"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(): void => {
                sendTealiumEvent(
                  "Step 2: Pick your policy",
                  "Learn More: Learn about costs"
                );
              }}
            >
              {t("medigap.policies.learn_about_costs")}
            </a>
          </p>
        </section>
      </div>
    </Card>
  );
};

export default MedigapPolicyCard;
